export enum TestType {
		None = 'None',
    YN = 'YN',
    Rubric = 'Rubric',
    Score = 'Score',
    General = 'General',
}